// src/app/pages/shared/badges-sheet/badges-sheet.component.ts
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarModule } from 'primeng/progressbar';
import { ButtonModule } from 'primeng/button';
import { NavController } from '@ionic/angular';
import { BadgeWithProgress } from 'src/app/services/badge.service';
import { 
  IonHeader, 
  IonToolbar, 
  IonTitle, 
  IonButtons, 
  IonButton, 
  IonIcon, 
  IonContent,
  IonSkeletonText,
  IonModal 
} from '@ionic/angular/standalone';

@Component({
  selector: 'app-badges-sheet',
  standalone: true,
  imports: [
    CommonModule,
    ProgressBarModule,
    ButtonModule,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonIcon,
    IonContent,
    IonSkeletonText
  ],
  templateUrl: './badges-sheet.component.html',
  styleUrls: ['./badges-sheet.component.scss'],
})
export class BadgesSheetComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  @Input() badges: any[] = [];
  @Input() isLoading: boolean = false;

  @Output() onClose = new EventEmitter<void>();
  @ViewChild(IonModal) modal!: IonModal;

  constructor(private _nav: NavController) { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['visible'] && this.visible) {
      // Reset any state if needed when dialog opens
    }
  }

  close() {
    this.onClose.emit();
  }

  getAchievedBadges(): any[] {
    return this.badges.filter(b => b.isAchieved);
  }

  getUnachievedBadges(): any[] {
    return this.badges.filter(b => !b.isAchieved);
  }

  viewBusinessHub(hubId: number) {
    this.close();
    this._nav.navigateForward(['/dashboard/business-hub', hubId]);
  }

  formatDate(dateString?: string): string {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    return date.toLocaleDateString('de-DE', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
}